<template>
  <div class="admin-records">
    <div>
      <ul>
        <li :class="{mobile: mobile}">
          <h4>{{ record.displayName }}</h4>
          <div class="icontain">
            <ClipboardCheckIcon
              class="icon"
              @click="toggleAttendanceRegisterModal"
            />
            <ChartSquareBarIcon
              class="icon"
              @click="toggleReportModal"
            />
            <TrashIcon
              class="icon"
              @click="doDelete"
            />
          </div>
        </li>
      </ul>
      <div v-if="showEditReportCard">
        <EditReportCard
          :record="record"
          @closer="toggleReportModal"
        />
      </div>
      <div v-if="showAttendanceRegister">
        <attendance-register-modal
          :record="record"
          @closer="toggleAttendanceRegisterModal"
        />
      </div>
      <confirm-dialogue ref="confirmDialog"></confirm-dialogue>
    </div>
    <teleport to="#modals">
    <transition name="toast">
      <toast v-if="toggleModal" msg="Attendance Register Updated"></toast>
    </transition>
    </teleport>
  </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import EditReportCard from '@/components/EditReportCard.vue'
import { inject, onMounted } from '@vue/runtime-core'
import { TrashIcon, ChartSquareBarIcon, ClipboardCheckIcon } from '@heroicons/vue/outline'
import { db, deleteDoc, doc } from '@/firebase/config'
import ConfirmDialogue from './ConfirmDialogue.vue'
import AttendanceRegisterModal from './AttendanceRegisterModal.vue'
import Toast from './Toast.vue'

export default {
  components: { TrashIcon, ChartSquareBarIcon, ClipboardCheckIcon, EditReportCard, ConfirmDialogue, AttendanceRegisterModal, Toast },
  props: ['record'],
  setup (props, context) {
    const mobile = ref(false)
    const showEditReportCard = ref(false)
    const showAttendanceRegister = ref(false)
    const windowWidth = ref(null)
    const currentUser = inject('currentUser')
    const confirmDialog = ref(null)
    const ok = ref(null)
    const toggleModal = ref(false)

    // deleteRecord
    const deleteUser = async () => {
      await deleteDoc(doc(db, '/schools/inspire-schools/' + currentUser.state.grade +
      '/reports/teacher', props.record.id))
      context.emit('deletion')
    }

    const toggleReportModal = ({ load }) => {
      showEditReportCard.value = !showEditReportCard.value
      if (load) {
        context.emit('deletion', { edit: true })
      }
    }

    const toggleAttendanceRegisterModal = ({ load }) => {
      showAttendanceRegister.value = !showAttendanceRegister.value
      if (load) {
        toggleModal.value = true
        context.emit('deletion', { edit: false })
        setTimeout(() => {
          toggleModal.value = false
        }, 3000)
      }
    }

    const doDelete = async () => {
      ok.value = await confirmDialog.value.show({
        title: 'Delete Learner Record',
        message: 'Are you sure you want to delete this record? It cannot be undone.',
        okButton: 'Delete',
        cancelButton: 'NO'
      })
      // If you throw an error, the method will terminate here unless you surround it wil try/catch
      if (ok.value) {
        await deleteUser()
      }
    }

    const handleview = () => {
      windowWidth.value = window.innerWidth
      if (windowWidth.value <= 750) {
        mobile.value = true
        return
      }
      mobile.value = false
    }

    onMounted(() => {
      handleview()
      window.addEventListener('resize', handleview)
    })

    return { mobile, deleteUser, showEditReportCard, toggleReportModal, confirmDialog, doDelete, showAttendanceRegister, toggleAttendanceRegisterModal, toggleModal }
  }
}
</script>

<style>
.admin-records {
  background: #fff;
}
.admin-records div {
  background: white;
  border: 1px solid pink;
  padding: 5px;
}
.admin-records li {
  list-style-type: none;
  background: #eee;
  padding: 10px 20px;
  margin: 5px auto;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.admin-records li.mobile {
  display: flex;
  flex-direction: column;
}
.admin-records .icon {
  max-width: 17px;
  cursor: pointer;
}
.admin-records p, h3, ul {
    padding: 0;
    margin: 0;
}
</style>
